import { Box, Text } from '@chakra-ui/react';
import { FC } from 'react';

export interface PrepStepHeaderProps {
  stepNumber: number;
  title: string;
  description?: string;
}

export const PrepStepHeader: FC<PrepStepHeaderProps> = ({
  stepNumber,
  title,
  description,
}) => {
  return (
    <Box mb={description ? 0 : 3}>
      <Text
        data-testid={`prep-step-header-${stepNumber}`}
        fontSize="xs"
        fontWeight="600"
        textTransform="uppercase"
        letterSpacing="0.5px"
        color="text.subtle"
      >
        Step {stepNumber}: {title}
      </Text>
      {description && (
        <Text fontSize="xs" color="text.default" mt="4px">
          {description}
        </Text>
      )}
    </Box>
  );
};

PrepStepHeader.displayName = 'PrepStepHeader';
